import React from "react";
import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";

import { faixaDatas } from "../lib/periodo";

// Uma linha "▲ 12,3% vs 01/08–21/08 (R$ 10.200,00)". O lojista pediu para ver
// COM O QUÊ está comparando: só a % não dizia nada (21/09/2026).
// `menorMelhor`: em tempo e cancelados, subir é ruim — a seta fica vermelha.
function Linha({ variacao, periodo, anterior, formatar, menorMelhor }) {
  const datas = faixaDatas(periodo);
  if (variacao == null) {
    return (
      <p className="text-[10px] text-muted-foreground leading-tight" data-e2e="comparacao">
        sem base em {datas}{anterior != null ? ` (${formatar(anterior)})` : ""}
      </p>
    );
  }
  const zero = variacao === 0;
  const bom = menorMelhor ? variacao < 0 : variacao > 0;
  const Icon = zero ? Minus : variacao > 0 ? ArrowUpRight : ArrowDownRight;
  const cor = zero ? "text-muted-foreground" : bom ? "text-green-600 dark:text-green-400" : "text-red-600 dark:text-red-400";
  return (
    <p className="text-[10px] leading-tight flex flex-wrap items-center gap-x-1" data-e2e="comparacao">
      <span className={`inline-flex items-center gap-0.5 font-semibold ${cor}`}>
        <Icon className="w-3 h-3" />{Math.abs(variacao).toFixed(1).replace(".", ",")}%
      </span>
      <span className="text-muted-foreground">vs {datas}</span>
      <span className="text-muted-foreground/80 tabular-nums">({formatar(anterior)})</span>
    </p>
  );
}

// As duas comparações do card: período anterior e mesmo período do ano passado.
export default function Comparacao({ dados, kpi, chave, formatar, menorMelhor = false }) {
  if (!dados?.periodo_anterior) return null;
  return (
    <div className="space-y-0.5 mt-1.5">
      <Linha variacao={dados[`variacao_${chave}_ontem`]} periodo={dados.periodo_anterior}
        anterior={dados.anterior?.[kpi]} formatar={formatar} menorMelhor={menorMelhor} />
      <Linha variacao={dados[`variacao_${chave}_ano_anterior`]} periodo={dados.periodo_ano_anterior}
        anterior={dados.ano_anterior?.[kpi]} formatar={formatar} menorMelhor={menorMelhor} />
    </div>
  );
}
